var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Delete_3961798",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.999,
    height: 21.309,
    viewBox: "0 0 16.999 21.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_63847",
    "data-name": "Path 63847",
    d: "M-4477.041,21.309a1.577,1.577,0,0,1-1.576-1.577V4.969h14.189V19.732A1.578,1.578,0,0,1-4466,21.309Zm7.095-13.186v9.244a.789.789,0,0,0,.788.788.789.789,0,0,0,.789-.788V8.123a.789.789,0,0,0-.789-.788.789.789,0,0,0-.788.788Zm-4.729,0v9.244a.788.788,0,0,0,.788.788.788.788,0,0,0,.788-.788V8.123a.788.788,0,0,0-.788-.788.788.788,0,0,0-.788.788Zm-4.367-3.813a.958.958,0,0,1-.958-.958.958.958,0,0,1,.958-.958h4.367V1.183A1.184,1.184,0,0,1-4473.493,0h3.941a1.184,1.184,0,0,1,1.183,1.183V2.394h4.41a.958.958,0,0,1,.958.958.958.958,0,0,1-.958.958Zm9.1-1.915V1.577h-3.153v.818Z",
    transform: "translate(4480)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8cd44abeefc3a8d7310eac4669b112a3.svg";
export { ForwardRef as ReactComponent };